const LOCALE_LOCALSTORAGE_KEY = 'locale';

export default {
  get: () => {
    return localStorage.getItem(LOCALE_LOCALSTORAGE_KEY);
  },
  set: (locale: string) => {
    return localStorage.setItem(LOCALE_LOCALSTORAGE_KEY, locale);
  },
  remove: () => {
    return localStorage.removeItem(LOCALE_LOCALSTORAGE_KEY);
  },
};
